import axios from '@/plugins/axios.js'

export function list(params){
    return axios.get("/public/yarnType/query",{params:params});
}